import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import "core-js/modules/es.regexp.exec.js";
import { defaultEncoder } from "./defaults/defaultEncoder";
import { defaultErrorResponseHandler } from "./defaults/defaultErrorResponseHandler";
import { defaultExceptionHandler } from "./defaults/defaultExceptionHandler";
import { defaultResponseHandler } from "./defaults/defaultResponseHandler";
import { fastOptionsMerge } from "./helper";
import { HttpTransport } from "./HttpTransport";
function buildUrl(url, baseUrl) {
  return baseUrl ? new _URL(url, baseUrl).toString() : url;
}
export var HttpRequest = _createClass(function HttpRequest(baseUrl, defaultOptions, handlerOverrides) {
  var _this = this;
  _classCallCheck(this, HttpRequest), _defineProperty(this, "baseUrl", void 0), _defineProperty(this, "defaultOptions", void 0), _defineProperty(this, "transport", void 0), _defineProperty(this, "handlers", void 0), _defineProperty(this, "onEncode", void 0), _defineProperty(this, "get", function (url, params, optionOverrides) {
    var _context,
      requestOptions = fastOptionsMerge(_this.defaultOptions, optionOverrides),
      requestUrl = _concatInstanceProperty(_context = "".concat(buildUrl(url, _this.baseUrl))).call(_context, function (params) {
        if (!params) return "";
        var fakeUrl = new _URL("http://www.gw.com");
        return _Object$keys(params).forEach(function (key) {
          var param = params[key];
          (Array.isArray(param) ? param : [param]).forEach(function (arrayValue) {
            return fakeUrl.searchParams.append(key, arrayValue);
          });
        }), fakeUrl.search;
      }(params));
    return _this.transport.fetch(requestUrl, "GET", requestOptions);
  }), _defineProperty(this, "post", function (url, data, optionOverrides) {
    return _this.request(url, "POST", data, optionOverrides);
  }), _defineProperty(this, "put", function (url, data, optionOverrides) {
    return _this.request(url, "PUT", data, optionOverrides);
  }), _defineProperty(this, "patch", function (url, data, optionOverrides) {
    return _this.request(url, "PATCH", data, optionOverrides);
  }), _defineProperty(this, "delete", function (url, data, optionOverrides) {
    return _this.request(url, "DELETE", data, optionOverrides);
  }), _defineProperty(this, "request", function (url, method, data, optionOverrides) {
    var requestOptions = fastOptionsMerge(_this.defaultOptions, optionOverrides);
    return data && (requestOptions.body = _this.onEncode(data, requestOptions)), _this.transport.fetch(buildUrl(url, _this.baseUrl), method, requestOptions);
  }), this.baseUrl = baseUrl, this.defaultOptions = defaultOptions, this.onEncode = (null == handlerOverrides ? void 0 : handlerOverrides.onEncode) || defaultEncoder, this.handlers = function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }({
    onErrorResponse: defaultErrorResponseHandler,
    onException: defaultExceptionHandler,
    onResponse: defaultResponseHandler
  }, handlerOverrides), this.transport = new HttpTransport(this.handlers);
});